import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { urpiweb } from './shared/helpers/constants';
import { DefaultOptions } from 'apollo-client';

const uri = urpiweb.url.graph; // <-- add the URL of the GraphQL server here

const authLink = setContext((_, { headers }) => {
  const token = urpiweb.auth.token;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'Ocp-Apim-Subscription-Key': urpiweb.auth.ocpkey,
      'VERSION-APP': urpiweb.auth.versionApp,
      //  "Access-Control-Allow-Origin": "http://localhost:4200",
      'VERSION-APP-PREVIOUS': urpiweb.auth.versionAppPrevious,
      'CANAL-DISTRIBUCION': 'WEB',
       // 🔒 Headers de seguridad (normalmente se colocan en el servidor)
  /*   
  "X-Frame-Options": "DENY",
  "X-Content-Type-Options": "nosniff",
  "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
  "Content-Security-Policy": "default-src 'self'",
  "Referrer-Policy": "no-referrer",
  "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
  "Cross-Origin-Embedder-Policy": "require-corp",
  "Cross-Origin-Resource-Policy": "same-origin",
  "Cross-Origin-Opener-Policy": "same-origin"*/
    }
  };
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

export function createApollo(httpLink: HttpLink) {
  return {
    link: authLink.concat(httpLink.create({uri, withCredentials: true})),
    // link: httpLink.create({uri}), //enable to test with local
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions
  };
}

@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink]
    },
  ],
})
export class GraphQLModule {}
